// The HQ console's front page: the first section the role may open (spec/14 §1's order), or — for a
// platform role no built section is open to yet — a plain sentence saying so.

import { useTranslation } from '@clavian/i18n/react';
import { Navigate } from '@tanstack/react-router';

import { usePlatformAccessHere } from './access';
import { visibleSections } from './sections';

export function HqHome() {
  const { t } = useTranslation('hq');
  const access = usePlatformAccessHere();
  const first = visibleSections(access.permissions)[0];
  if (first !== undefined) return <Navigate to={first.to} replace />;
  return (
    <div className="console-page">
      <h1 className="console-page__title">{t('home.title')}</h1>
      <p>{t('home.nothingOpen')}</p>
    </div>
  );
}
